module.exports = __webpack_public_path__ + "img/aw.9f96e65f.svg";